import Grid from "@mui/material/Grid";

import GCAutocompleteCheckbox from "../../../Component/Common/ReuseableComponent/GCAutocompleteCheckbox";
import {
  CmpTypographyField,
  CmpSelectField,
  CmpDatePickerField,
  CmpRadioButton,
} from "../../../Component/Common/ToolBox/ToolBox.js";
import { Autocomplete, TextField } from "@mui/material";

export default function WmsHead({
  sLocationData,
  userList,
  HeadObject,
  setHeadObject,
  getUserList,
  fFromDate,
  fToDate,
  fReportType,
}) {
  return (
    <form id="BranchToDcTsrDetailReportHead">
      <Grid
        container
        rowSpacing={{ xs: 0, sm: 0, md: 1 }}
        columnSpacing={{ xs: 0, sm: 0, md: 0 }}
        columns={{ xs: 12, sm: 12, md: 12 }}
      >
        <Grid
          item
          xs={12}
          sm={12}
          md={12}
          className="d-flex align-items-center"
        >
          <CmpTypographyField
            xcomponent={"h1"}
            xText={"Pickers Performance Report"}
            xfontSize="20px"
            xtextDecoration="underline"
          />
        </Grid>

        <Grid item xs={12} sm={12} md={12}>
          <Grid
            container
            rowSpacing={{ xs: 0, sm: 0, md: 1 }}
            columnSpacing={{ xs: 0, sm: 0, md: 1 }}
            columns={{ xs: 12, sm: 12, md: 12 }}
            alignItems="center"
          >
            <Grid item xs={3} sm={3} md={1.3} lg={1.3}>
              <CmpTypographyField xcomponent={"span"} xText={"Date"} />
            </Grid>
            <Grid item xs={3} sm={3} md={4} lg={4}>
              <CmpDatePickerField
                xValue={HeadObject.pFromDate}
                xOnChange={fFromDate}
                xName={"pFromDate"}
                xError={false}
                xErrorMessage={""}
              />
            </Grid>
            <Grid item xs={3} sm={3} md={4} lg={4}>
              <CmpDatePickerField
                xValue={HeadObject.pToDate}
                xOnChange={fToDate}
                xName={"pToDate"}
                xError={false}
                xErrorMessage={""}
              />
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={12} sm={12} md={12}>
          <Grid
            container
            rowSpacing={{ xs: 0, sm: 0, md: 1 }}
            columnSpacing={{ xs: 0, sm: 0, md: 1 }}
            columns={{ xs: 12, sm: 12, md: 12 }}
            alignItems="center"
          >
            <Grid item xs={3} sm={3} md={1.3} lg={1.3}>
              <CmpTypographyField xcomponent={"span"} xText={"Location"} />
            </Grid>
            <Grid item xs={6} sm={6} md={8} lg={8}>
              <Autocomplete
                sx={{
                  "& .MuiOutlinedInput-root": {
                    padding: "0px !important",
                  },
                  "& .MuiInputBase-input": {
                    padding: "5.5px 10px !important",
                  },
                }}
                freeSolo
                id="free-solo-2-demo"
                disableClearable
                options={sLocationData}
                getOptionLabel={(option) =>
                  typeof option === "string"
                    ? option || ""
                    : option?.Name1 || ""
                }
                value={HeadObject?.pLocation || ""}
                onChange={(event, newValue) => {
                  setHeadObject((prev) => ({
                    ...prev,
                    pLocation: newValue,
                  }));
                  getUserList(newValue?.Cd || {});

                  // setHeadErrors((prev) => ({
                  //   ...prev,
                  //   pLocation: "",
                  // }));
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    // error={headErrors?.location === "" ? false : true}
                    // helperText={headErrors?.location}
                    slotProps={{
                      input: {
                        ...params.InputProps,
                        type: "search",
                      },
                    }}
                  />
                )}
              />
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={12} sm={12} md={12}>
          <Grid
            container
            rowSpacing={{ xs: 0, sm: 0, md: 1 }}
            columnSpacing={{ xs: 0, sm: 0, md: 1 }}
            columns={{ xs: 12, sm: 12, md: 12 }}
            alignItems="center"
          >
            <Grid item xs={3} sm={3} md={1.3} lg={1.3}>
              <CmpTypographyField xcomponent={"span"} xText={"User"} />
            </Grid>
            <Grid item xs={6} sm={6} md={8} lg={8}>
              <Autocomplete
                sx={{
                  "& .MuiOutlinedInput-root": {
                    padding: "0px !important",
                  },
                  "& .MuiInputBase-input": {
                    padding: "5.5px 10px !important",
                  },
                }}
                freeSolo
                id="free-solo-2-demo"
                disableClearable
                options={userList}
                getOptionLabel={(option) =>
                  typeof option === "string"
                    ? option || ""
                    : option?.Name1 || ""
                }
                value={HeadObject?.pUser || {}}
                onChange={(event, newValue) => {
                  setHeadObject((prev) => ({
                    ...prev,
                    pUser: newValue,
                  }));
                  // setHeadErrors((prev) => ({
                  //   ...prev,
                  //   pUser: "",
                  // }));
                }}
                // disabled={settingDetail.length > 0}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    // error={headErrors?.location === "" ? false : true}
                    // helperText={headErrors?.location}
                    slotProps={{
                      input: {
                        ...params.InputProps,
                        type: "search",
                      },
                    }}
                  />
                )}
              />
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={12} sm={12} md={12}>
          <Grid
            container
            rowSpacing={{ xs: 0, sm: 0, md: 1 }}
            columnSpacing={{ xs: 0, sm: 0, md: 1 }}
            columns={{ xs: 12, sm: 12, md: 12 }}
            alignItems="center"
          >
            <Grid item xs={3} sm={3} md={1.3} lg={1.3}>
              <CmpTypographyField xcomponent={"span"} xText={"Report Type"} />
            </Grid>
            <Grid item xs={3} sm={3} md={1.5} lg={1.5}>
              <CmpRadioButton
                value="Summary"
                label="Summary"
                checked={HeadObject.pReportType === "Summary"}
                onChange={fReportType}
              />
            </Grid>
            <Grid item xs={3} sm={3} md={1.5} lg={1.5}>
              <CmpRadioButton
                value="Detail"
                label="Detail"
                checked={HeadObject.pReportType === "Detail"}
                onChange={fReportType}
              />
            </Grid>
            <Grid item xs={3} sm={3} md={1.5} lg={1.5}>
              <CmpRadioButton
                value="Userwise"
                label="Userwise"
                checked={HeadObject.pReportType === "Userwise"}
                onChange={fReportType}
              />
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </form>
  );
}
